import { Box, useTheme } from '@chakra-ui/react';
import { useTableCellContext } from 'components/Table/TableCell/context';

const TableCellScore = () => {
  const theme = useTheme();

  const context = useTableCellContext();

  if (context.cellType === 'score') {
    const {
      score,
      maxScore,
      borderRadius,
      height,
      minHeight,
      margin,
      flexJustifyContent,
      scoreFontFamily,
      scoreFontSize,
      scoreLineHeight,
      scoreFontWeight,
      scoreColor,
      maxScoreFontFamily,
      maxScoreFontSize,
      maxScoreLineHeight,
      maxScoreFontWeight,
      maxScoreColor,
      dataTestId,
      onClick
    } = context;

    const handleCellClick = () => {
      if (onClick) {
        onClick();
      }
    };

    return (
      <Box
        display='flex'
        justifyContent={flexJustifyContent || 'center'}
        height={height || 'max-content'}
        minHeight={minHeight || 'max-content'}
        margin={margin || 0}
        borderRadius={borderRadius || 0}
        cursor={onClick ? 'pointer' : 'default'}
        data-testid={dataTestId || 'cjtable-score-cell-id'}
        onClick={handleCellClick}
      >
        <Box
          color={scoreColor || theme.colors?.greenExplorer}
          fontFamily={scoreFontFamily || theme.fonts.semiBold}
          fontSize={scoreFontSize || '24px'}
          fontWeight={scoreFontWeight || '600'}
          lineHeight={scoreLineHeight || '24px'}
          data-testid='cjtable-score-cell-score'
        >
          {score}
        </Box>
        <Box
          color={maxScoreColor || theme.colors.mediumGrey}
          fontFamily={maxScoreFontFamily || theme.fonts.semiBold}
          fontSize={maxScoreFontSize || '14px'}
          fontWeight={maxScoreFontWeight || '600'}
          lineHeight={maxScoreLineHeight || '24px'}
          marginLeft='4px'
          data-testid='cjtable-score-cell-maxScore'
        >
          {`/ ${maxScore || '5'}`}
        </Box>
      </Box>
    );
  }
  return null;
};

export default TableCellScore;
